module.exports = __webpack_public_path__ + "static/full1-d3bc94121db91a0c4c218503391df1ae.jpg";